module.exports = __webpack_public_path__ + "static/Caro_Jon_Japan.02e50a83.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Caro_Jon_Japan.png
// module id = 93
// module chunks = 104101334113578 114276838955818